<template>
    <multi-selector
        :available="available"
        :selected="selected"
        :disabled="disabled"
        available-title="Medidores disponíveis"
        selected-title="Medidores selecionados"
        @select="select"
        @deselect="deselect"
    />
</template>

<script>
import MultiSelector from "@/components/MultiSelector";
import differenceBy from "@/utils/differenceBy";

export default {
    name: "TriaxialJointSelector",
    components: {
        MultiSelector
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: []
        };
    },
    computed: {
        triaxialJoints() {
            return this.$store.state.julho_14.triaxialJoints;
        },
        available() {
            return differenceBy(this.triaxialJoints, this.selected, "id");
        }
    },
    methods: {
        select(data) {
            const selected = this.selected.concat(data);

            selected.sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                }

                if (a.name < b.name) {
                    return -1;
                }

                return 0;
            });

            this.selected = selected;
        },
        deselect(data) {
            this.selected = differenceBy(this.selected, data, "id");
        }
    }
};
</script>
